import { Link } from "react-router-dom";
import { FirmarkMark } from "./FirmarkMark";

export function PublicFooter() {
  return (
    <footer className="landing-footer">
      <div className="landing-wrap landing-footer-grid">
        <div className="footer-brand-col">
          <span className="landing-footer-brand">
            <FirmarkMark size={18} />
            <span className="brand-word" style={{ fontSize: 15 }}>Firmark</span>
          </span>
          <p className="footer-tagline">
            The structural engineering &amp; design harness. You set the standards, AI
            supervises, your PE stamps.
          </p>
        </div>

        <div className="footer-links-col">
          <div className="footer-col-title">Platform</div>
          <Link to="/platform/design-engine">Design engine</Link>
          <Link to="/platform/engineering">Engineering &amp; codes</Link>
          <Link to="/security">Security</Link>
          <Link to="/#control-modes">Control modes</Link>
          <Link to="/#pricing">Pricing</Link>
        </div>

        <div className="footer-links-col">
          <div className="footer-col-title">Resources</div>
          <Link to="/learn">Learn</Link>
          <Link to="/help">Help &amp; documentation</Link>
          <Link to="/#for-engineers">For engineers</Link>
          <Link to="/#for-builders">For builders</Link>
          <Link to="/#faq">FAQ</Link>
        </div>

        <div className="footer-links-col">
          <div className="footer-col-title">Get started</div>
          <Link to="/beta?intent=demo">Book a demo</Link>
          <Link to="/beta?intent=waitlist">Join the beta</Link>
          <Link to="/plans">Send us a plan</Link>
          <Link to="/login">Sign in</Link>
        </div>
      </div>

      <div className="landing-wrap footer-legal">
        <span className="footer-legal-copy">© 2026 Firmark · Engineering Studio</span>
        <nav className="footer-legal-links" aria-label="Legal &amp; contact">
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/beta?intent=demo">Contact</Link>
        </nav>
      </div>
    </footer>
  );
}
